<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Donor Clinical Information EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2 fieldName">
            In EMR
          </div>
          <div class="col-2 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="bloodType"
              disabled
              label="Blood Type"
              :class="{ highlightField: isDifferent(bloodType, bloodTypeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="bloodTypeOATS"
              disabled
              label="Blood Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="rhFactor"
              disabled
              label="RH Factor"
              :class="{ highlightField: isDifferent(rhFactor, rhFactorOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="rhFactorOATS"
              disabled
              label="RH Factor"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="aboSubType"
              disabled
              label="ABO Sub Type"
              :class="{ highlightField: isDifferent(aboSubType, aboSubTypeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="aboSubTypeOATS"
              disabled
              label="ABO Sub Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="bloodTypeVerified"
              disabled
              label="Blood Type Verified"
              :class="{ highlightField: isDifferent(bloodTypeVerified, bloodTypeVerifiedOATS) }"
            />
          </div> 
          <div class="col-2">
            <ADSTextInput
              v-model="bloodTypeVerifiedOATS"
              disabled
              label="Blood Type Verified"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistribution"
              disabled
              label="Exceptional Distribution Indicator"
              :class="{ highlightField: isDifferent(exceptionalDistribution, exceptionalDistributionOATS) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionOATS"
              disabled
              label="Exceptional Distribution Indicator"
            />
          </div>
        </div>

        <br><br>

        <div class="row">
          <div class="col-5">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReason"
              class="ExceptionalDistributionReason"
              disabled
              label="Exceptional Distribution Reason-EMR"
              :class="{ highlightField: isDifferent(exceptionalDistributionReason, exceptionalDistributionReasonOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReasonOATS"
              class="ExceptionalDistributionReason"
              disabled
              label="Exceptional Distribution Reason-OATS"
            />
          </div>
        </div>

        <br><br>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="exceptionalDistributionReasonTravel"
              disabled
              label="Exceptional Distribution Reason Travel-EMR"
              :class="{ highlightField: isDifferent(exceptionalDistributionReasonTravel, exceptionalDistributionReasonTravelOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="exceptionalDistributionReasonTravelOATS"
              disabled
              label="Exceptional Distribution Reason Travel-OATS"
            />
          </div>
        </div>

        <br><br>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReasonOther"
              class="ExceptionalDistributionReasonOther"
              disabled
              label="Exceptional Distribution Reason Other-EMR"
              :class="{ highlightField: isDifferent(exceptionalDistributionReasonOther, exceptionalDistributionReasonOtherOATS) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <ADSTextInput
              id="disabled-text"
              v-model="exceptionalDistributionReasonOtherOATS"
              class="ExceptionalDistributionReasonOther"
              disabled
              label="Exceptional Distribution Reason Other-OATS"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DonorClinicalInformationSectionEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      // livingDonorToDonateTo: this.getLivingDonorToDonateTo( this.patientBundle ),
      // preSelectedRecipient: this.getPreSelectedRecipient( this.patientBundle ),
      // toBeAllocatedToARecipient: this.getToBeAllocatedToARecipient( this.patientBundle ),
      bloodType: this.getBloodType( this.patientBundle ),
      bloodTypeOATS: this.getBloodTypeOATS( this.patientBundleOATS ),
      aboSubType: this.getABOSubType( this.patientBundle ),
      aboSubTypeOATS: this.getABOSubTypeOATS( this.patientBundleOATS ),
      rhFactor: this.getRHFactor( this.patientBundle ),
      rhFactorOATS: this.getRHFactorOATS( this.patientBundleOATS ),
      bloodTypeVerified: this.getBloodTypeVerified( this.patientBundle ),
      bloodTypeVerifiedOATS: this.getBloodTypeVerifiedOATS( this.patientBundleOATS ),
      exceptionalDistribution: this.getExceptionalDistribution( this.patientBundle ),
      exceptionalDistributionOATS: this.getExceptionalDistributionOATS( this.patientBundleOATS ), 
      exceptionalDistributionReason: this.getExceptionalDistributionReason( this.patientBundle ),
      exceptionalDistributionReasonOATS: this.getExceptionalDistributionReasonOATS( this.patientBundleOATS ),
      exceptionalDistributionReasonOther: this.getExceptionalDistributionReasonOther( this.patientBundle ),
      exceptionalDistributionReasonOtherOATS: this.getExceptionalDistributionReasonOtherOATS( this.patientBundleOATS ),
      exceptionalDistributionReasonTravel: this.getExceptionalDistributionReasonTravel( this.patientBundle ),
      exceptionalDistributionReasonTravelOATS: this.getExceptionalDistributionReasonTravelOATS( this.patientBundleOATS ),
      //cPRA: this.getCPRA( this.patientBundle ),
      // height: this.getHeight( this.patientBundle ),
      // weight: this.getWeight( this.patientBundle ),
      heightList: this.getHeightList( this.patientBundle ),
      weightList: this.getWeightList( this.patientBundle ),
      heightWeightListCombined: this.getCombinedList( this.getHeightList( this.patientBundle ), this.getWeightList( this.patientBundle ) ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
  },
    // getLivingDonorToDonateTo( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let livingDonorToDonateTo = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#361' ) ) ;
    //   if( livingDonorToDonateTo && livingDonorToDonateTo[ 0 ]?.resource.code.text ) {
    //     return _.get( livingDonorToDonateTo[0], 'resource.component[0].valueString' );   
    //   } 
    //   }
    // },
    // getPreSelectedRecipient( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let preSelectedRecipient = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#362' ) ) ;
    //   if( preSelectedRecipient && preSelectedRecipient[0 ]?.resource.code.text ) {
    //     return _.get( preSelectedRecipient[0], 'resource.component[0].valueString' ); 
    //   }   
    // }
    // },
    // getToBeAllocatedToARecipient( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let toBeAllocatedToARecipient = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#363' ) ) ;
    //   if( toBeAllocatedToARecipient && toBeAllocatedToARecipient[0 ]?.resource.code.text ) {
    //     return _.get( toBeAllocatedToARecipient[0], 'resource.component[0].valueString' ); 
    //   }   
    // }
    // },
  
     getBloodType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let bloodType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3569' ) ) ;
      if( bloodType && bloodType[ 0 ] ) {
        return _.get( bloodType[ 0 ], 'resource.component[0].valueString' );  
      } 
      }
    },
    getBloodTypeOATS( patientBundleOATS ) {
      return patientBundleOATS?.blood?.type;
    },
    getABOSubType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let aboSubType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4054' ) ) ;
      if( aboSubType && aboSubType[ 0 ] ) {
        return _.get( aboSubType[0], 'resource.component[0].valueString' );    
      } 
      }
    },
    getABOSubTypeOATS( patientBundleOATS ) {
      return patientBundleOATS?.blood?.sub_type;
    },
    getRHFactor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let rhFactor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3570' ) ) ;
      if( rhFactor && rhFactor[ 0 ] ) {
        return _.get( rhFactor[0], 'resource.component[0].valueString' );    
      } 
      }
    },
    getRHFactorOATS( patientBundleOATS ) {
      if( patientBundleOATS?.blood?.rh == null || patientBundleOATS?.blood?.rh === '' ) 
      return '';
      return patientBundleOATS?.blood?.rh === '+' ? 'Positive' : patientBundleOATS?.blood?.rh === '-' ? 'Negative' : 'Unknown';
    },
    getBloodTypeVerified( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let bloodTypeVerified = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3552' ) ) ;
      if( bloodTypeVerified && bloodTypeVerified[ 0 ] ) {
        return _.get( bloodTypeVerified[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ;    
      } 
      }
    },
    getBloodTypeVerifiedOATS( patientBundleOATS ) {
      if( patientBundleOATS?.blood?.type_verified == null || patientBundleOATS?.blood?.type_verified === '' ) 
      return '';
      return patientBundleOATS?.blood?.type_verified ? 'Checked' : 'Unchecked' ;
    },
    getExceptionalDistribution( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistribution = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3969' ) ) ;
      if( exceptionalDistribution && exceptionalDistribution[ 0 ] ) {
        return _.get( exceptionalDistribution[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ;    
      } 
      }
    },
    getExceptionalDistributionOATS( patientBundleOATS ) {
      if( patientBundleOATS?.indicators?.exceptional_distribution == null || 
      patientBundleOATS?.indicators?.exceptional_distribution === '' ) 
      return '';
      return patientBundleOATS?.indicators?.exceptional_distribution ? 'Checked' : 'Unchecked' ;
    },
    getExceptionalDistributionReason( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistributionReason = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3829' ) ) ;
      if( exceptionalDistributionReason && exceptionalDistributionReason[ 0 ] ) {
        let components = _.get( exceptionalDistributionReason[ 0 ], 'resource.component', [] );
        return ( components || [] )
          .map( ( c ) => _.get( c, 'valueString' ) )
          .filter( ( v ) => v !== undefined && v !== null && String( v ).trim() !== '' )
          .join( ', ' );    
      } 
      }
    },
    getExceptionalDistributionReasonOATS( patientBundleOATS ) {
      const indicators = patientBundleOATS?.indicators ?? {};

      // backend mirror: createLivingDonorIndicators() in
      // backend/src/modules/handler_functions/client/TGLN/donor_vitals_handler/donor_vitals_handler_h1_0_0.js
      const exd_reason_codes = []
        .concat( indicators.exd_reason_codes ?? [] )
        .filter( ( v ) => v !== undefined && v !== null && String( v ).trim() !== '' )
        .map( ( v ) => Number( v ) )
        .filter( Number.isFinite );

      // Prefer a single canonical label per code for display.
      // (value_conversions.js has multiple source strings mapping to the same code.)
      const labelByCode = {
        102: 'History of malignancy',
        200: 'Travel to/lived in history with risk for',
        300: 'Other',
        401: 'IRD Non-medical injection of drugs in preceding 12 months',
        402: 'IRD Known sex history risk',
        403: 'IRD Incarceration > 72 hours in last 12 months',
        404: 'IRD Tattoo/piercing with non-sterile procedures < 12 months',
        405: 'IRD Intranasal drug use for non-medical reasons < 6 months',
        500: 'Positive for Sexually Transmitted Infection',
        501: 'Hep B Core +',
      };

      const otherDetails = String( indicators.exd_reason_details_other ?? '' ).trim();
      const travelDetails = String( indicators.exd_reason_details_travel ?? '' ).trim();

      // Merge logic: OATS codes may include 300 multiple times; show it once.
      const seen = new Set();
      const parts = [];

      for( const code of exd_reason_codes ) {
        if( seen.has( code ) ) continue;
        seen.add( code );

        const baseLabel = labelByCode[ code ] ?? String( code );

        if( code === 300 && otherDetails ) {
          parts.push( `${baseLabel} (${otherDetails})` );
        } else if( code === 200 && travelDetails ) {
          parts.push( `${baseLabel} (${travelDetails})` );
        } else {
          parts.push( baseLabel );
        }
      }

      return parts.join( ', ' );
    },
    getExceptionalDistributionReasonOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistributionReasonOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3830' ) ) ;
      if( exceptionalDistributionReasonOther && exceptionalDistributionReasonOther[ 0 ] ) {
        return _.get( exceptionalDistributionReasonOther[0], 'resource.component[0].valueString' );     
      } 
      }
    },
    getExceptionalDistributionReasonOtherOATS( patientBundleOATS ) {
      return patientBundleOATS?.indicators?.exd_reason_details_other;
    },
    getExceptionalDistributionReasonTravelOATS( patientBundleOATS ) {
      return patientBundleOATS?.indicators?.exd_reason_details_travel;
    },
    getExceptionalDistributionReasonTravel( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let exceptionalDistributionReasonTravel = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3831' ) ) ;
      if( exceptionalDistributionReasonTravel && exceptionalDistributionReasonTravel[ 0 ] ) {
        return _.get( exceptionalDistributionReasonTravel[0], 'resource.component[0].valueString' );     
      } 
      }
    },
    // getCPRA( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let cpra = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#135' ) ) ; 
    //   if( cpra && cpra[0 ]?.resource.code.text ) {
    //     return _.get( cpra[0], 'resource.component[0].valueString' );  
    //   }   
    // }
    // },
    // getHeight( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let vitalSigns = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'vital-signs' ) ) ;
    //   if( vitalSigns && vitalSigns[ 0 ] ) {
    //     for( let item of vitalSigns ) {
    //     for( let x of item?.resource?.code?.coding ) {
    //          if( x.code === '8302-2' && x.system === "http://loinc.org" ) {
    //           return item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit;
    //          }
    //     }
    //   }
    //   }
    //   }
    // },
    getHeightList( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) && 
      _.get( n[ 0 ], 'resource.category[0].coding[0].code' ) === 'vital-signs' );
      if( observation && observation[ 0 ] ) {
      let vitalSigns = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'vital-signs' ) ) ;
      let heightList = [];
        for( let item of vitalSigns ) {
          if( item?.resource?.code?.coding ) {
        for( let x of item?.resource?.code?.coding ) {
             if( x.code === '8302-2' && x.system === "http://loinc.org" ) {
              heightList.push( { 'height' : item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit, 'measurementDate' : item.resource?.effectiveDateTime?.substring( 0,10 ) } );
             }
        }
      }
      }
      return heightList;
      }
      return [];
    },
    getWeightList( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) && 
      _.get( n[ 0 ], 'resource.category[0].coding[0].code' ) === 'vital-signs' );   
      if( observation && observation[ 0 ] ) {
      let heightList = [];
        for( let item of observation[ 0 ] ) {
        if( item?.resource?.code?.coding ) {
          for( let x of item?.resource?.code?.coding ) {
             if( x.code === '29463-7' && x.system === "http://loinc.org" ) {
              heightList.push( { 'weight' : item.resource?.valueQuantity?.value + ' ' + item.resource?.valueQuantity?.unit, 'measurementDate' : item.resource?.effectiveDateTime?.substring( 0,10 ) } );
             }
        }
        }
      }
      return heightList;
      }
      return [];
    },
    getCombinedList( heightList, weightList ) {
      let length = heightList.length > weightList.length ? heightList.length : weightList.length;
      let combinedList = [];

      for( let x=0; x<length; x++ ) {
        combinedList.push( { 'height' : _.get( heightList[ x ], 'height', '' ), 'measurementDateHeight' : _.get( heightList[ x ], 'measurementDate', '' ), 
        'weight' : _.get( weightList[ x ], 'weight', '' ), 'measurementDateWeight' : _.get( weightList[ x ], 'measurementDate', '' ) } )
       
      }
      return combinedList;
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 340px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}
.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1350px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
  width: 800px;
}

:deep(.ExceptionalDistributionReason .afflo-ds-form-control) {
  width: 1150px;
}

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

</style>
